// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.query-directory-tree {
  background: none !important;
}
.query-directory-tree .ant-tree-treenode {
  padding: 0 !important;
  margin-bottom: 2px;
}

.query-directory-tree .ant-tree-node-content-wrapper {
  width: 100%;
  padding: 0 !important;
}

/* Hide indent and switcher for query nodes only */
.query-directory-tree .query-tree-node {
  cursor: pointer;
}

.query-directory-tree .query-tree-node .ant-tree-iconEle {
  display: none !important;
}

.query-directory-tree .query-tree-node .ant-tree-switcher {
  display: none !important;
  width: 0 !important;
}

.query-directory-tree .query-tree-node .ant-tree-indent {
  display: none !important;
}

.query-directory-tree .query-tree-node .ant-tree-node-content-wrapper {
  padding-left: 0 !important;
}

.query-directory-tree .ant-tree-title {
  width: 100%;
}

/* Query Item Card Styling */
.query-item-card {
  cursor: pointer;
  width: 100%;
}

.query-item-content {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  padding-right: 8px;
}

.query-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--ant-color-text);
  line-height: 1.4;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
}

.query-description {
  font-size: 11px;
  color: var(--ant-color-text-secondary);
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
}

.query-actions {
  opacity: 0;
  transition: opacity 0.2s;
  flex-shrink: 0;
}

.query-item-card:hover .query-actions {
  opacity: 1;
}

.query-actions .ant-btn {
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.query-actions .ant-btn .anticon {
  font-size: 14px;
}

`, "",{"version":3,"sources":["webpack://./src/modules/SqlConsole/SavedQueriesSidebar/style.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA,kDAAkD;AAClD;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".query-directory-tree {\n  background: none !important;\n}\n.query-directory-tree .ant-tree-treenode {\n  padding: 0 !important;\n  margin-bottom: 2px;\n}\n\n.query-directory-tree .ant-tree-node-content-wrapper {\n  width: 100%;\n  padding: 0 !important;\n}\n\n/* Hide indent and switcher for query nodes only */\n.query-directory-tree .query-tree-node {\n  cursor: pointer;\n}\n\n.query-directory-tree .query-tree-node .ant-tree-iconEle {\n  display: none !important;\n}\n\n.query-directory-tree .query-tree-node .ant-tree-switcher {\n  display: none !important;\n  width: 0 !important;\n}\n\n.query-directory-tree .query-tree-node .ant-tree-indent {\n  display: none !important;\n}\n\n.query-directory-tree .query-tree-node .ant-tree-node-content-wrapper {\n  padding-left: 0 !important;\n}\n\n.query-directory-tree .ant-tree-title {\n  width: 100%;\n}\n\n/* Query Item Card Styling */\n.query-item-card {\n  cursor: pointer;\n  width: 100%;\n}\n\n.query-item-content {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  padding-right: 8px;\n}\n\n.query-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ant-color-text);\n  line-height: 1.4;\n  margin-bottom: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  word-break: break-word;\n}\n\n.query-description {\n  font-size: 11px;\n  color: var(--ant-color-text-secondary);\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  word-break: break-word;\n}\n\n.query-actions {\n  opacity: 0;\n  transition: opacity 0.2s;\n  flex-shrink: 0;\n}\n\n.query-item-card:hover .query-actions {\n  opacity: 1;\n}\n\n.query-actions .ant-btn {\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.query-actions .ant-btn .anticon {\n  font-size: 14px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
